/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RfItemAttachmentsBox_ItemFragment = { __typename: 'Item', id: string, authorOrganisationId: string };

export type RfItemAttachmentsBoxQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
}>;


export type RfItemAttachmentsBoxQuery = { rfGetItemAttachments: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'RfGetItemAttachmentsResult', attachments: Array<{ __typename: 'RfItemAttachment', id: string, title: string, mimeType: string, url: string, docType?: string | null, xObjectId?: string | null, status: Types.RfItemAttachmentStatus, clientVisibility: boolean }> } };

export type RfItemAttachmentsGetUploadUrlMutationVariables = Types.Exact<{
  input: Types.RfGetItemAttachmentUploadUrlInput;
}>;


export type RfItemAttachmentsGetUploadUrlMutation = { rfGetItemAttachmentUploadUrl: { __typename: 'rfGetItemAttachmentUploadUrlResult', uploadUrl: string, persistedUri: string, s3Key: string } };

export type RfItemAttachmentsAddMutationVariables = Types.Exact<{
  input: Types.RfAddItemAttachmentsInput;
}>;


export type RfItemAttachmentsAddMutation = { rfAddItemAttachments: { __typename: 'rfAddItemAttachmentsResult', attachments: Array<{ __typename: 'RfItemAttachment', id: string, title: string, mimeType: string, url: string, docType?: string | null, xObjectId?: string | null, status: Types.RfItemAttachmentStatus }> } };

export type RfItemAttachmentsResolveDocumentTypesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
  fileName: Types.Scalars['String']['input'];
}>;


export type RfItemAttachmentsResolveDocumentTypesQuery = { quoteSapS4HanaData?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteSapS4HanaData', id: string, xAvailableDocumentTypes?: Array<{ __typename: 'QuoteSapS4HanaDataAvailableValue', value: string, label: string }> | null } | null };

export type RfItemAttachmentModifyMutationVariables = Types.Exact<{
  input: Types.RfModifyItemAttachmentInput;
}>;


export type RfItemAttachmentModifyMutation = { rfModifyItemAttachment: { __typename: 'rfModifyItemAttachmentResult', ok: boolean } };

export type RfRemoveItemAttachmentMutationVariables = Types.Exact<{
  input: Types.RfRemoveItemAttachmentInput;
}>;


export type RfRemoveItemAttachmentMutation = { rfRemoveItemAttachment: { __typename: 'rfRemoveItemAttachmentResult', ok: boolean } };

export type SetRfItemAttachmentClientVisibilityMutationVariables = Types.Exact<{
  input: Types.SetItemAttachmentClientVisibilityInput;
}>;


export type SetRfItemAttachmentClientVisibilityMutation = { setItemAttachmentClientVisibility: { __typename: 'SetItemAttachmentClientVisibilityResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string } | { __typename: 'QuoteTemplate', id: string } | { __typename: 'Requirement', id: string }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null } } };

export const RfItemAttachmentsBox_ItemFragmentDoc = gql`
    fragment RfItemAttachmentsBox_Item on Item {
  id
  authorOrganisationId
}
    `;
export const RfItemAttachmentsBoxDocument = gql`
    query RfItemAttachmentsBox($projectId: ID!, $docId: ID!, $itemId: ID!) {
  rfGetItemAttachments(projectId: $projectId, docId: $docId, itemId: $itemId) {
    ... on RfGetItemAttachmentsResult {
      attachments {
        id
        title
        mimeType
        url
        docType
        xObjectId
        status
        clientVisibility
      }
    }
  }
}
    `;

/**
 * __useRfItemAttachmentsBoxQuery__
 *
 * To run a query within a React component, call `useRfItemAttachmentsBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useRfItemAttachmentsBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRfItemAttachmentsBoxQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useRfItemAttachmentsBoxQuery(baseOptions: Apollo.QueryHookOptions<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables> & ({ variables: RfItemAttachmentsBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>(RfItemAttachmentsBoxDocument, options);
      }
export function useRfItemAttachmentsBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>(RfItemAttachmentsBoxDocument, options);
        }
export function useRfItemAttachmentsBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>(RfItemAttachmentsBoxDocument, options);
        }
export type RfItemAttachmentsBoxQueryHookResult = ReturnType<typeof useRfItemAttachmentsBoxQuery>;
export type RfItemAttachmentsBoxLazyQueryHookResult = ReturnType<typeof useRfItemAttachmentsBoxLazyQuery>;
export type RfItemAttachmentsBoxSuspenseQueryHookResult = ReturnType<typeof useRfItemAttachmentsBoxSuspenseQuery>;
export type RfItemAttachmentsBoxQueryResult = Apollo.QueryResult<RfItemAttachmentsBoxQuery, RfItemAttachmentsBoxQueryVariables>;
export const RfItemAttachmentsGetUploadUrlDocument = gql`
    mutation RfItemAttachmentsGetUploadUrl($input: rfGetItemAttachmentUploadUrlInput!) {
  rfGetItemAttachmentUploadUrl(input: $input) {
    uploadUrl
    persistedUri
    s3Key
  }
}
    `;
export type RfItemAttachmentsGetUploadUrlMutationFn = Apollo.MutationFunction<RfItemAttachmentsGetUploadUrlMutation, RfItemAttachmentsGetUploadUrlMutationVariables>;

/**
 * __useRfItemAttachmentsGetUploadUrlMutation__
 *
 * To run a mutation, you first call `useRfItemAttachmentsGetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRfItemAttachmentsGetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rfItemAttachmentsGetUploadUrlMutation, { data, loading, error }] = useRfItemAttachmentsGetUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRfItemAttachmentsGetUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RfItemAttachmentsGetUploadUrlMutation, RfItemAttachmentsGetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RfItemAttachmentsGetUploadUrlMutation, RfItemAttachmentsGetUploadUrlMutationVariables>(RfItemAttachmentsGetUploadUrlDocument, options);
      }
export type RfItemAttachmentsGetUploadUrlMutationHookResult = ReturnType<typeof useRfItemAttachmentsGetUploadUrlMutation>;
export type RfItemAttachmentsGetUploadUrlMutationResult = Apollo.MutationResult<RfItemAttachmentsGetUploadUrlMutation>;
export type RfItemAttachmentsGetUploadUrlMutationOptions = Apollo.BaseMutationOptions<RfItemAttachmentsGetUploadUrlMutation, RfItemAttachmentsGetUploadUrlMutationVariables>;
export const RfItemAttachmentsAddDocument = gql`
    mutation RfItemAttachmentsAdd($input: rfAddItemAttachmentsInput!) {
  rfAddItemAttachments(input: $input) {
    attachments {
      id
      title
      mimeType
      url
      docType
      xObjectId
      status
    }
  }
}
    `;
export type RfItemAttachmentsAddMutationFn = Apollo.MutationFunction<RfItemAttachmentsAddMutation, RfItemAttachmentsAddMutationVariables>;

/**
 * __useRfItemAttachmentsAddMutation__
 *
 * To run a mutation, you first call `useRfItemAttachmentsAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRfItemAttachmentsAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rfItemAttachmentsAddMutation, { data, loading, error }] = useRfItemAttachmentsAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRfItemAttachmentsAddMutation(baseOptions?: Apollo.MutationHookOptions<RfItemAttachmentsAddMutation, RfItemAttachmentsAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RfItemAttachmentsAddMutation, RfItemAttachmentsAddMutationVariables>(RfItemAttachmentsAddDocument, options);
      }
export type RfItemAttachmentsAddMutationHookResult = ReturnType<typeof useRfItemAttachmentsAddMutation>;
export type RfItemAttachmentsAddMutationResult = Apollo.MutationResult<RfItemAttachmentsAddMutation>;
export type RfItemAttachmentsAddMutationOptions = Apollo.BaseMutationOptions<RfItemAttachmentsAddMutation, RfItemAttachmentsAddMutationVariables>;
export const RfItemAttachmentsResolveDocumentTypesDocument = gql`
    query RfItemAttachmentsResolveDocumentTypes($projectId: ID!, $docId: ID!, $fileName: String!) {
  quoteSapS4HanaData(projectId: $projectId, docId: $docId) {
    ... on QuoteSapS4HanaData {
      id
      xAvailableDocumentTypes(fileName: $fileName) {
        value
        label
      }
    }
  }
}
    `;

/**
 * __useRfItemAttachmentsResolveDocumentTypesQuery__
 *
 * To run a query within a React component, call `useRfItemAttachmentsResolveDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRfItemAttachmentsResolveDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRfItemAttachmentsResolveDocumentTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useRfItemAttachmentsResolveDocumentTypesQuery(baseOptions: Apollo.QueryHookOptions<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables> & ({ variables: RfItemAttachmentsResolveDocumentTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>(RfItemAttachmentsResolveDocumentTypesDocument, options);
      }
export function useRfItemAttachmentsResolveDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>(RfItemAttachmentsResolveDocumentTypesDocument, options);
        }
export function useRfItemAttachmentsResolveDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>(RfItemAttachmentsResolveDocumentTypesDocument, options);
        }
export type RfItemAttachmentsResolveDocumentTypesQueryHookResult = ReturnType<typeof useRfItemAttachmentsResolveDocumentTypesQuery>;
export type RfItemAttachmentsResolveDocumentTypesLazyQueryHookResult = ReturnType<typeof useRfItemAttachmentsResolveDocumentTypesLazyQuery>;
export type RfItemAttachmentsResolveDocumentTypesSuspenseQueryHookResult = ReturnType<typeof useRfItemAttachmentsResolveDocumentTypesSuspenseQuery>;
export type RfItemAttachmentsResolveDocumentTypesQueryResult = Apollo.QueryResult<RfItemAttachmentsResolveDocumentTypesQuery, RfItemAttachmentsResolveDocumentTypesQueryVariables>;
export const RfItemAttachmentModifyDocument = gql`
    mutation RfItemAttachmentModify($input: rfModifyItemAttachmentInput!) {
  rfModifyItemAttachment(input: $input) {
    ok
  }
}
    `;
export type RfItemAttachmentModifyMutationFn = Apollo.MutationFunction<RfItemAttachmentModifyMutation, RfItemAttachmentModifyMutationVariables>;

/**
 * __useRfItemAttachmentModifyMutation__
 *
 * To run a mutation, you first call `useRfItemAttachmentModifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRfItemAttachmentModifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rfItemAttachmentModifyMutation, { data, loading, error }] = useRfItemAttachmentModifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRfItemAttachmentModifyMutation(baseOptions?: Apollo.MutationHookOptions<RfItemAttachmentModifyMutation, RfItemAttachmentModifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RfItemAttachmentModifyMutation, RfItemAttachmentModifyMutationVariables>(RfItemAttachmentModifyDocument, options);
      }
export type RfItemAttachmentModifyMutationHookResult = ReturnType<typeof useRfItemAttachmentModifyMutation>;
export type RfItemAttachmentModifyMutationResult = Apollo.MutationResult<RfItemAttachmentModifyMutation>;
export type RfItemAttachmentModifyMutationOptions = Apollo.BaseMutationOptions<RfItemAttachmentModifyMutation, RfItemAttachmentModifyMutationVariables>;
export const RfRemoveItemAttachmentDocument = gql`
    mutation RfRemoveItemAttachment($input: rfRemoveItemAttachmentInput!) {
  rfRemoveItemAttachment(input: $input) {
    ok
  }
}
    `;
export type RfRemoveItemAttachmentMutationFn = Apollo.MutationFunction<RfRemoveItemAttachmentMutation, RfRemoveItemAttachmentMutationVariables>;

/**
 * __useRfRemoveItemAttachmentMutation__
 *
 * To run a mutation, you first call `useRfRemoveItemAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRfRemoveItemAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rfRemoveItemAttachmentMutation, { data, loading, error }] = useRfRemoveItemAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRfRemoveItemAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RfRemoveItemAttachmentMutation, RfRemoveItemAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RfRemoveItemAttachmentMutation, RfRemoveItemAttachmentMutationVariables>(RfRemoveItemAttachmentDocument, options);
      }
export type RfRemoveItemAttachmentMutationHookResult = ReturnType<typeof useRfRemoveItemAttachmentMutation>;
export type RfRemoveItemAttachmentMutationResult = Apollo.MutationResult<RfRemoveItemAttachmentMutation>;
export type RfRemoveItemAttachmentMutationOptions = Apollo.BaseMutationOptions<RfRemoveItemAttachmentMutation, RfRemoveItemAttachmentMutationVariables>;
export const SetRfItemAttachmentClientVisibilityDocument = gql`
    mutation SetRfItemAttachmentClientVisibility($input: SetItemAttachmentClientVisibilityInput!) {
  setItemAttachmentClientVisibility(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
    }
    item {
      id
      originVersionNumber
    }
  }
}
    `;
export type SetRfItemAttachmentClientVisibilityMutationFn = Apollo.MutationFunction<SetRfItemAttachmentClientVisibilityMutation, SetRfItemAttachmentClientVisibilityMutationVariables>;

/**
 * __useSetRfItemAttachmentClientVisibilityMutation__
 *
 * To run a mutation, you first call `useSetRfItemAttachmentClientVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRfItemAttachmentClientVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRfItemAttachmentClientVisibilityMutation, { data, loading, error }] = useSetRfItemAttachmentClientVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRfItemAttachmentClientVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetRfItemAttachmentClientVisibilityMutation, SetRfItemAttachmentClientVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRfItemAttachmentClientVisibilityMutation, SetRfItemAttachmentClientVisibilityMutationVariables>(SetRfItemAttachmentClientVisibilityDocument, options);
      }
export type SetRfItemAttachmentClientVisibilityMutationHookResult = ReturnType<typeof useSetRfItemAttachmentClientVisibilityMutation>;
export type SetRfItemAttachmentClientVisibilityMutationResult = Apollo.MutationResult<SetRfItemAttachmentClientVisibilityMutation>;
export type SetRfItemAttachmentClientVisibilityMutationOptions = Apollo.BaseMutationOptions<SetRfItemAttachmentClientVisibilityMutation, SetRfItemAttachmentClientVisibilityMutationVariables>;